import classNames from "classnames";
import { observer } from "mobx-react";
import React, { useState } from "react";
import { ClickAwayListener } from "@fidget/common/components/form/clickAwayListener";
import { L10n } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { TagGroupPicker } from "../../../../components/forms/tagPicker/tagGroupPicker";
import { useStore } from "../../../../models";
import { GlobalFilterTypes, IFilterTagGroup } from "../../../../models/inbox/ConcreteGlobalFilters";
import { ITagGroup } from "../../../../models/tagGroups/TagGroupStore";
import styles from "../expandedFilters.css";
import { cloneDeep } from "lodash";

interface Props {
  resetState(): void;
}

export const TagGroupFilter = observer(({ resetState }: Props) => {
  const { inboxStore } = useStore();
  const [isPickingTagGroup, setIsPickingTagGroup] = useState(false);
  const filter = inboxStore.globalFilter.getFilter(GlobalFilterTypes.TagGroup) as
    | IFilterTagGroup
    | undefined;
  const [pickedTag] = filter?.tagGroups || [];

  const handleTagChosen = (tagGroup: ITagGroup) => {
    inboxStore.globalFilter.activateTagGroupFilter([{ ...cloneDeep(tagGroup) }]);
    resetState();
  };

  const handleClicked = () => {
    if (!isPickingTagGroup) {
      if (pickedTag) {
        inboxStore.globalFilter.deactivateFilter(GlobalFilterTypes.TagGroup);
      } else {
        setIsPickingTagGroup(true);
      }
    }
  };

  const renderTagPickerContainer = () => {
    return (
      <ClickAwayListener
        onClickAway={() => setIsPickingTagGroup(false)}
        className={styles["tag-picker-container"]}
      >
        <TagGroupPicker
          initialIsOpen
          onChange={handleTagChosen}
          onStateChange={(_, state) => !state.isOpen && setIsPickingTagGroup(false)}
          placeholder={intl.formatMessage("inbox.moreFilters.global.withTagGroup")}
        />
      </ClickAwayListener>
    );
  };

  return (
    <>
      <div
        className={classNames(styles["entry-container"], { [styles.selected]: !!filter })}
        onClick={handleClicked}
      >
        {isPickingTagGroup ? (
          renderTagPickerContainer()
        ) : (
          <>
            <div>
              <L10n id="inbox.moreFilters.global.withTagGroup" />
              {pickedTag && <p className={styles["entry-desc"]}>{pickedTag.name}</p>}
            </div>
            {filter && (
              <div className={styles.applied}>
                <L10n id={"inbox.moreFilters.applied"} />
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
});
